import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import purple from '@material-ui/core/colors/purple';
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';

const styles = theme => ({
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

function NumberFormatCustom(props) 
  {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        decimalScale={2}
        fixedDecimalScale={true}
        onValueChange={values => {
          onChange({
            target: {
              id:"total_cost",
              value: values.value,
            },
          });
        }}
        thousandSeparator
      />
    );
  }

class GeneralActualCostInfo extends Component {
  
  static propTypes = {

  };

  state = {
  };


  handleChange = name => event => 
  {

   this.props.handleChange({target:{value:event.target.checked?1:0,id:name}});
  }



  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Actual Cost Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '90%'}}
              id="invoice_date"
              label="Invoice Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.actual_cost.invoice_date}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.invoice_date}
              helperText={this.props.errores.invoice_date}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '90%'}}
              id="record_date"
              label="Record Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.actual_cost.record_date}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.record_date}
              helperText={this.props.errores.record_date}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="check_deliverable" style={{marginRight:'10px'}}>Commited Date</InputLabel>
            <Switch
              classes={{
                switchBase: classes.iOSSwitchBase,
                bar: classes.iOSBar,
                icon: classes.iOSIcon,
                iconChecked: classes.iOSIconChecked,
                checked: classes.iOSChecked,
              }}
              disableRipple
              checked={this.props.actual_cost.commited_date===1?true:false}
              onChange={this.handleChange('commited_date')}
              value="commited_date"
            />
          </Grid>
           <Grid item xs={12} sm={6}>
            <TextField
              id="total_cost"
              label="Total Cost"
              type="text"
              value={this.props.actual_cost.total_cost}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.total_cost}
              helperText={this.props.errores.total_cost}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}


export default (withStyles(styles)(GeneralActualCostInfo));




// WEBPACK FOOTER //
// ./src/features/actual/GeneralActualCostInfo.js